function replace(str: string, args: Record<string, unknown> = {}): string {
    if (typeof str !== 'string' || !args || typeof args !== 'object') {
        return str;
    }

    const regex = /\{([^}]+)\}/g;

    function toReplaceValue(value: unknown, fallback: string): string {
        if (value == null) {
            return '';
        }

        if (typeof value === 'string') {
            return value;
        }

        if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') {
            return `${value}`;
        }

        return fallback;
    }

    return str.replace(regex, function (match, capture): any {
        const keys = capture.split(',').map((key: string): any => key.trim());

        for (const key of keys) {
            if (Object.hasOwn(args, key)) {
                const value = args[key];

                return toReplaceValue(value, match);
            }
        }

        return match;
    });
}

// ----------------------------------------------------------------------------

export default replace;
